module.exports = __webpack_public_path__ + "static/media/Dropdown-arrow-disabled.894cc245.svg";